import { makeStyles, mergeClasses } from "@fluentui/react-components";

const useAppTooltipStyles = makeStyles({
  root: {
    maxWidth: "350px",
    "@media (forced-colors: active)": {
      color: "ButtonText",
    },
  },
});

export const useAppTooltipClass = (tooltipClassName?: string) => {
  const styles = useAppTooltipStyles();
  return mergeClasses(styles.root, tooltipClassName);
};
